import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-23/task-01";

const task: Slide = {
  title: "Different elements related to the design elements are listed below.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
